export const firebaseConfig = {
  apiKey: 'AIzaSyCBZdCeJ2dBz96gcR8LZ-0CQkRLXXHVQw0',
  authDomain: 'siteline-prod.firebaseapp.com',
  databaseURL: 'https://siteline-prod.firebaseio.com',
  projectId: 'siteline-prod',
  storageBucket: 'siteline-prod.appspot.com',
  messagingSenderId: '946320597438',
  appId: '1:946320597438:web:54b5c7e565b123917699ef',
  measurementId: 'G-7MPRR0Q4KR',
}

export const apiBaseUrl = 'api-admin.siteline.com'
export const subscriptionsBaseUrl = 'subscriptions-admin.siteline.com'
export const pdfBaseUrl = 'https://pdf.siteline.com'
export const reportingBaseUrl = 'https://reporting.siteline.com'
export const googleMapsApiKey = 'AIzaSyCBZdCeJ2dBz96gcR8LZ-0CQkRLXXHVQw0'
export const logRocketApiUrl = 'https://4c05439.siteline.com/i'
export const sentryTunnel = 'https://759ed53.siteline.com/api/5375023/envelope/'
export const dash0EndpointUrl = 'https://ingress.us-west-2.aws.dash0.com'
export const dash0AuthToken = 'auth_IKEtGAQhlaMKlk8Z0q3jcWyyBlcABcwP'
export const dash0ServiceName = 'siteline-admin'
